import { FC, Suspense } from "react";

import { Section } from "../ui/section/section";
import { ShimmerUI } from "../ui/shimmer-ui";
import { SuspenseErrorBoundary } from "./suspense-error-boundary";

export interface SuspenseShimmerProps {
  hideError?: boolean;
}

export const SuspenseShimmer: FC<SuspenseShimmerProps> = ({
  hideError,
  children,
}) => {
  return (
    <Suspense
      fallback={
        <Section darkBackground>
          <ShimmerUI />
        </Section>
      }
    >
      <SuspenseErrorBoundary hideError={hideError}>
        {children}
      </SuspenseErrorBoundary>
    </Suspense>
  );
};
